import { useParams } from 'react-router-dom'
import { AppBar, Box, Toolbar } from '@mui/material'
import { Organization } from '../../types/organization'
import { useGetProfile } from '../../api/auth'
import ActionsPanel from '../common/ActionsPanel'
import ProcessTitle from './ProcessTitle'
import Link from '@mui/material/Link'

interface Props {
  year?: string
  number?: string
  organization?: Organization
  description?: string
  stageName?: string
  stageId?: string
}

export default function ProcessInfo({
  year = '',
  number = '',
  description = '',
  organization,
  stageName,
  stageId,
}: Props) {
  const { pid } = useParams<{ pid: string }>()
  const { data: user } = useGetProfile()
  return (
    <AppBar position="sticky">
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <ProcessTitle
            description={description}
            number={number}
            stageId={stageId}
            pid={pid}
            organization={organization}
            year={year}
          />
          {stageName && (
            <Link
              href={`/${pid}/stage/${stageId}`}
              fontSize="small"
              underline="none"
              color="text.light"
            >
              {'مرحله ' + stageName}
            </Link>
          )}
        </Box>
        <Box>
          <ActionsPanel />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
